<div class="page">
    <div class="page-head">
        <div>
            <h2>{{ pageTitle() }}</h2>
            <p>Define the categories used by series masters (e.g. Invoice, Policy, Claim).</p>
        </div>
        <p-button label="Add Type" icon="pi pi-plus" (onClick)="openAdd()" />
    </div>

    <div class="card">
        <p-table [value]="types()" [loading]="loading()" [rows]="10"
            [paginator]="types().length > 10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm"
            [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 80px">ID</th>
                    <th>Type Name</th>
                    <th>Series Name</th>
                    <th>Created</th>
                    <th class="ta-r" style="width: 110px">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-t>
                <tr>
                    <td class="mono">{{ displayId(t) }}</td>
                    <td class="strong">{{ displayName(t) }}</td>
                    <td>{{ t.seriesName || '—' }}</td>
                    <td class="muted">{{ t.createdAt | indDate }}</td>
                    <td class="ta-r">
                        <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary"
                            pTooltip="Edit" (onClick)="openEdit(t)" />
                        <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
                            pTooltip="Delete" (onClick)="remove(t)" />
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5">
                        <div class="state"><i class="pi pi-inbox"></i><p>No series types yet. Click <strong>Add Type</strong> to create one.</p></div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- ===================== ADD / EDIT MODAL ===================== -->
<p-dialog [visible]="showModal()" (visibleChange)="showModal.set($event)" [modal]="true"
    [draggable]="true" [resizable]="false" [closable]="true" [dismissableMask]="false"
    [header]="editing() ? 'Edit Series Type' : 'Add Series Type'" styleClass="menu-dialog"
    [style]="{ width: '420px' }" [breakpoints]="{ '480px': '94vw' }">
    <div class="menu-form">
        <div class="field">
            <label>Type Name <span class="req">*</span></label>
            <input type="text" pInputText [ngModel]="name()" (ngModelChange)="name.set($event)" placeholder="e.g. Invoice"
                (keyup.enter)="save()">
        </div>
        <div class="modal-actions">
            <p-button label="Cancel" [outlined]="true" (onClick)="closeModal()" />
            <p-button [label]="saving() ? 'Saving...' : 'Save'"
                [icon]="saving() ? 'pi pi-spin pi-spinner' : ''" (onClick)="save()" [loading]="saving()" />
        </div>
    </div>
</p-dialog>
